export default "__VITE_ASSET__e25fa5ee__"